export const locationStatuses = [
    { id: 'planend', label: 'vorgesehen' },
    { id: 'active', label: 'aktiv' },
    { id: 'inactive', label: 'inaktiv' },
];
